<template>
  <v-container grid-list-lg fluid text-xs-center>

    <div class="text-xs-center">
      <v-chip close v-for="item in store.home.categories.items" :key="item.id"
        v-if="item.selected"
        @input="item.selected = false">
        {{ item.name }}
      </v-chip>
    </div>

    <v-progress-circular v-if="store.home.promotions.status == 'loading'" indeterminate color="primary">
    </v-progress-circular>

    <v-alert :value="store.home.promotions.status == 'error'" type="warning">
      No se pudo recuperar la lista de promociones. Por favor intente nuevamente.
    </v-alert>

    <v-layout row wrap>

      <v-flex xs12 sm6 md4 lg3 v-for="item in store.home.promotions.items" :key="item.id">

        <promotion-item :data="item"></promotion-item>

      </v-flex>

    </v-layout>

    <category-list></category-list>
  </v-container>
</template>

<script>
import epromo from '@/services/epromo'
import PromotionItem from '@/components/promotions/Item'
import CategoryList from './CategoryList'
import store from '@/store'

export default {
  components: {
    PromotionItem,
    CategoryList
  },
  data: () => ({
    store
  }),
  mounted () {
    let promotions = this.store.home.promotions

    epromo.get('/api/v2/promotions?with=categories')
      .then(response => {
        promotions.status = 'loaded'
        promotions.items = response.data.data
      })
      .catch(error => {
        console.log(error)
        promotions.status = 'error'
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promotions/List.vue